<template>
    <div class="counters-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Time Counter</h3>
                </div>
                <div class="time-counter">
                    <div id="timer" class="flex-wrap justify-content-center d-flex">
                        <div
                            id="days"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{days}}
                            <span>Days</span>
                        </div>
                        <div
                            id="hours"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{hours}}
                            <span>Hours</span>
                        </div>
                        <div
                            id="minutes"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{minutes}}
                            <span>Minutes</span>
                        </div>
                        <div
                            id="seconds"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{seconds}}
                            <span>Seconds</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Time Counter Border Less</h3>
                </div>

                <div class="time-counter border-less">
                    <div id="timer" class="flex-wrap justify-content-center d-flex">
                        <div
                            id="days"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{days}}
                            <span>Days</span>
                        </div>
                        <div
                            id="hours"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{hours}}
                            <span>Hours</span>
                        </div>
                        <div
                            id="minutes"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{minutes}}
                            <span>Minutes</span>
                        </div>
                        <div
                            id="seconds"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{seconds}}
                            <span>Seconds</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Time Counter background</h3>
                </div>

                <div class="time-counter background-color">
                    <div id="timer" class="flex-wrap justify-content-center d-flex">
                        <div
                            id="days"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{days}}
                            <span>Days</span>
                        </div>
                        <div
                            id="hours"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{hours}}
                            <span>Hours</span>
                        </div>
                        <div
                            id="minutes"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{minutes}}
                            <span>Minutes</span>
                        </div>
                        <div
                            id="seconds"
                            class="align-items-center flex-column d-flex justify-content-center"
                        >
                            {{seconds}}
                            <span>Seconds</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CountersContent',
    data() {
        return {
            days: '',
            hours: '',
            minutes: '',
            seconds: ''
        }
    },
    created() { // Turn data into viewable values
        setInterval(() => {
            this.commingSoonTime();
        }, 1000);
    },
    methods: {
        commingSoonTime() {
            let endTime = new Date("December 5, 2025 17:00:00 PDT");            
            let endTimeParse = (Date.parse(endTime)) / 1000;
            let now = new Date();
            let nowParse = (Date.parse(now) / 1000);
            let timeLeft = endTimeParse - nowParse;
            let days = Math.floor(timeLeft / 86400);
            let hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            let minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
            let seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }
            this.days = days;
            this.hours = hours;
            this.minutes = minutes;
            this.seconds = seconds;
        }
    },
}
</script>

<style lang="scss">
.time-counter {
	#timer {
		div {
			border: 2px solid var(--main-color);
			color: var(--main-color);
			width: 85px;
			height: 85px;
			border-radius: 5px;
			font-size: 30px;
			font-weight: 800;
			margin-left: 10px;
			margin-right: 10px;
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			span {
				display: block;
				margin-top: -2px;
				font-size: 14px;
				font-weight: 600;
			}
		}
	}
	&.border-less {
		#timer {
			div { 
				border: none;
			}
		}
	}
	&.background-color {
		#timer {
			div { 
				border: none;
				background-color: var(--main-color);
				color: var(--white-color);
			}
		}
	}
}
</style>